module.exports = __webpack_public_path__ + "img/tertiary_7x3.148dfb17.svg";